
import { mapState } from 'vuex';
import ProductSliderItem from '@/components/blocks/productSliderItem.vue';
import Slider from '@/components/ui/slider.vue';

export default {
  name: 'ProductSlider',

  components: {
    ProductSliderItem,
    Slider,
  },

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapState(['inShop']),

    tabletPerView() {
      return this.inShop ? 2 : 3;
    },
    desktopPerView() {
      return this.inShop ? 3 : 4;
    },
  },
};
